// extracted by mini-css-extract-plugin
export default {"alertTitle":"style_alertTitle__ytnYl","countryChip":"style_countryChip__8PB0L"};